// finds a key on an object that is above a certain threshhold
// eg { 'fooObjectId': { '1:1': { '800': 'string url' } } }
// it returns the id. eg fooObjectId
const keyAboveThreshhold = (obj, threshhold) => {
  if (typeof obj !== 'object') {
    return false;
  }
  return Object.keys(obj).find(
    (key) => +key >= threshhold || keyAboveThreshhold(obj[key], threshhold)
  );
};

export default keyAboveThreshhold;
